import { createStore } from 'vuex'

export default createStore({
    state: {
        count: 0,
        activeMenu: '/progressive',
        activeTab: 1,
        activeFundTab: 1,
        lastAccessedFundId: null,
        activePageTitle: 'セキュリテ',
        numberItemsInCart: 0,
        flushActive: false,
        flushMessage: '',
        referrerUrl: '',
        numberAcountBadge: 0
    },
    getters: {
        activeTab: state => state.activeTab,
        activeMenu: state => state.activeMenu,
        activeFundTab: state => state.activeFundTab,
        lastAccessedFundId: state => state.lastAccessedFundId,
        activePageTitle: state => state.activePageTitle,
        numberItemsInCart: state => state.numberItemsInCart,
        flushActive: state => state.flushActive,
        flushMessage: state => state.flushMessage,
        referrerUrl: state => state.referrerUrl,
        numberAcountBadge: state => state.numberAcountBadge
     },
    mutations: {
        increment(state){
            state.count += 1
        },
        decrement(state){
            state.count -= 1
        },
        setActiveMenu(state, activeMenu){
            state.activeMenu = activeMenu
        },
        setActivetab(state, activeTab){
            state.activeTab = activeTab
        },
        setActiveFundtab(state, activeTab){
            state.activeFundTab = activeTab
        },
        setLastAccessedFundId(state, lastAccessedFundId){
            state.lastAccessedFundId = lastAccessedFundId
        },
        setActivePageTitle(state, activePageTitle){
            state.activePageTitle = activePageTitle
        },
        setNumberItemsInCart(state, numberItemsInCart){
            state.numberItemsInCart = numberItemsInCart
        },
        setFlushActive(state, flushActive){
            state.flushActive = flushActive
        },
        setFlushMessage(state, flushMessage){
            state.flushMessage = flushMessage
            state.flushActive = true
        },
        setReferrerUrl(state, referrerUrl){
            state.referrerUrl = referrerUrl
        },
        setAccountBadge(state, numberAcountBadge){
            state.numberAcountBadge = numberAcountBadge
        }
    },
    actions: {
        setActiveMenu({commit}, activeMenu){
            commit('setActiveMenu', activeMenu)
        },
        setActivetab({commit}, activeTab){
            commit('setActivetab', activeTab)
        },
        setActiveFundtab({commit}, activeTab){
            commit('setActiveFundtab', activeTab)
        },
        setLastAccessedFundId({commit}, lastAccessedFundId){
            commit('setLastAccessedFundId', lastAccessedFundId)
        },
        setActivePageTitle({commit}, activePageTitle){
            commit('setActivePageTitle', activePageTitle)
        },
        setNumberItemsInCart({commit}, numberItemsInCart){
            commit('setNumberItemsInCart', numberItemsInCart)
        },
        setFlushActive({commit}, flushActive){
            commit('setFlushActive', flushActive)
        },
        setFlushMessage({commit}, flushMessage){
            commit('setFlushMessage', flushMessage)
        },
        setReferrerUrl({commit}, referrerUrl){
            commit('setReferrerUrl', referrerUrl)
        },
        setAccountBadge({commit}, numberAcountBadge){
            commit('setAccountBadge', numberAcountBadge)
        }
    },
    modules: {
    }
})
